<template>
  <div class="animated fadeIn">
    <div class="timestamp">Guru • {{time}}</div>
    <div id="bot" class="row">
      <div class="col-sm-1">
        <img class="avatarL d-inline" src="@/assets/home-page-images/guru.png" alt />
      </div>
      <div class="col-sm-9" v-if="res.data.text != 'request_callback'">
        <div class="botCard ml-1">
          <!-- <img src="@/assets/larsenLogo.png" alt=""> -->
          <div class="d-inline-block treatNewLine">
            <p class="botText" v-html="gurufy(res.data.text)"></p>
          </div>
          <div class="buttons text-center" v-for="(btn, i) in res.data.buttons" :key="i">
            <button class="btn btn-outline-primary chat-btn" @click="btnClick(btn)">{{btn.title}}</button>
          </div>
        </div>
      </div>
      <div class="col-sm-9" v-if="res.data.text == 'request_callback' && lang=='en-IN'">
        <div class="botCard ml-1">
          <div class="text-left mx-1 ml-1">
            <w-text-input
              :labelName="'Person Name*'"
              @textInputChange="getPersonName($event)"
              validation="required"
              :defaultValue="form.name"
              :allowOnlyCharacters="true"
              :maxCharacter="'100'"
            />
          </div>
          <div class="text-left mx-1 ml-1">
            <w-text-input
              :labelName="'Company Name*'"
              @textInputChange="getCompanyName($event)"
              validation="required"
              :defaultValue="form.companyName"
              :allowOnlyCharacters="true"
              :maxCharacter="'100'"
            />
          </div>
          <div class="text-left mx-1 ml-1">
            <w-text-input
              :inputAdditions="'mobile'"
              :labelName="'Mobile Number*'"
              validation="required|regex_mobile_number"
              @textInputChange="getMobileNumber($event)"
              :isdCode="'+91'"
              :defaultValue="form.mobile"
              :type="'number'"
              :maxDigits="'10'"
            />
          </div>
          <div class="text-left mx-1 ml-1">
            <w-text-input
              :labelName="'Email Id*'"
              @textInputChange="getEmail($event)"
              validation="required|email"
              :defaultValue="form.email"
              :maxCharacter="'100'"
            />
          </div>

          <b-button
            :disabled="checkForm() || isSubmitClicked"
            @click="submitCallback()"
            class="eip-link ml-auto mr-auto"
          >Submit</b-button>
        </div>
      </div>

      
      <div class="col-sm-9" v-if="res.data.text == 'request_callback' && lang=='hi-IN'">
        <div class="botCard ml-1">
          <div class="text-left mx-1 ml-1">
            <w-text-input
              :labelName="'व्यक्ति का नाम*'"
              @textInputChange="getPersonName($event)"
              validation="required"
              :defaultValue="form.name"
              :allowOnlyCharacters="true"
              :maxCharacter="'100'"
            />
          </div>
          <div class="text-left mx-1 ml-1">
            <w-text-input
              :labelName="'कंपनी का नाम*'"
              @textInputChange="getCompanyName($event)"
              validation="required"
              :defaultValue="form.companyName"
              :allowOnlyCharacters="true"
              :maxCharacter="'100'"
            />
          </div>
          <div class="text-left mx-1 ml-1">
            <w-text-input
              :inputAdditions="'mobile'"
              :labelName="'मोबाइल नंबर*'"
              validation="required|regex_mobile_number"
              @textInputChange="getMobileNumber($event)"
              :isdCode="'+91'"
              :defaultValue="form.mobile"
              :type="'number'"
              :maxDigits="'10'"
            />
          </div>
          <div class="text-left mx-1 ml-1">
            <w-text-input
              :labelName="'ईमेल आईडी*'"
              @textInputChange="getEmail($event)"
              validation="required|email"
              :defaultValue="form.email"
              :maxCharacter="'100'"
            />
          </div>

          <b-button
            :disabled="checkForm() || isSubmitClicked"
            @click="submitCallback()"
            class="eip-link ml-auto mr-auto"
          >प्रस्तुत</b-button>
        </div>
      </div>

      
      <div class="col-sm-9" v-if="res.data.text == 'request_callback' && lang=='ta-IN'">
        <div class="botCard ml-1">
          <div class="text-left mx-1 ml-1">
            <w-text-input
              :labelName="'நபரின் பெயர்*'"
              @textInputChange="getPersonName($event)"
              validation="required"
              :defaultValue="form.name"
              :allowOnlyCharacters="true"
              :maxCharacter="'100'"
            />
          </div>
          <div class="text-left mx-1 ml-1">
            <w-text-input
              :labelName="'நிறுவனத்தின் பெயர்*'"
              @textInputChange="getCompanyName($event)"
              validation="required"
              :defaultValue="form.companyName"
              :allowOnlyCharacters="true"
              :maxCharacter="'100'"
            />
          </div>
          <div class="text-left mx-1 ml-1">
            <w-text-input
              :inputAdditions="'mobile'"
              :labelName="'கைபேசி எண்*'"
              validation="required|regex_mobile_number"
              @textInputChange="getMobileNumber($event)"
              :isdCode="'+91'"
              :defaultValue="form.mobile"
              :type="'number'"
              :maxDigits="'10'"
            />
          </div>
          <div class="text-left mx-1 ml-1">
            <w-text-input
              :labelName="'மின்னஞ்சல் முகவரி*'"
              @textInputChange="getEmail($event)"
              validation="required|email"
              :defaultValue="form.email"
              :maxCharacter="'100'"
            />
          </div>

          <b-button
            :disabled="checkForm() || isSubmitClicked"
            @click="submitCallback()"
            class="eip-link ml-auto mr-auto"
          >சமர்ப்பிக்கவும்</b-button>
        </div>
      </div>

      
      <div class="col-sm-9" v-if="res.data.text == 'request_callback' && lang=='te-IN'">
        <div class="botCard ml-1">
          <div class="text-left mx-1 ml-1">
            <w-text-input
              :labelName="'వ్యక్తి పేరు*'"
              @textInputChange="getPersonName($event)"
              validation="required"
              :defaultValue="form.name"
              :allowOnlyCharacters="true"
              :maxCharacter="'100'"
            />
          </div>
          <div class="text-left mx-1 ml-1">
            <w-text-input
              :labelName="'కంపెనీ పేరు*'"
              @textInputChange="getCompanyName($event)"
              validation="required"
              :defaultValue="form.companyName"
              :allowOnlyCharacters="true"
              :maxCharacter="'100'"
            />
          </div>
          <div class="text-left mx-1 ml-1">
            <w-text-input
              :inputAdditions="'mobile'"
              :labelName="'మొబైల్ సంఖ్య*'"
              validation="required|regex_mobile_number"
              @textInputChange="getMobileNumber($event)"
              :isdCode="'+91'"
              :defaultValue="form.mobile"
              :type="'number'"
              :maxDigits="'10'"
            />
          </div>
          <div class="text-left mx-1 ml-1">
            <w-text-input
              :labelName="'ఇమెయిల్ ఐడి*'"
              @textInputChange="getEmail($event)"
              validation="required|email"
              :defaultValue="form.email"
              :maxCharacter="'100'"
            />
          </div>

          <b-button
            :disabled="checkForm() || isSubmitClicked"
            @click="submitCallback()"
            class="eip-link ml-auto mr-auto"
          >సమర్పించండి</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextInput from "../../../widgets/TextInput.vue";
export default {
  components: {
    "w-text-input": TextInput
  },
  name: "Bot",
  props: ["res", "lang"], 
  created() {
    // console.log(this.formatAMPM(this.res.time));
  },
  watch: { 
      	res: function(newVal, oldVal) { // watch it
          if (newVal.data.text == 'request_callback') {
            this.isSubmitClicked = false
          }
        }
      },
  data() {
    return {
      isSubmitClicked: false,
      time: this.formatAMPM(this.res.time),
      form: {
        name: "",
        email: "",
        mobile: "",
        companyName: ""
      }
    };
  },
  methods: {
    gurufy(res){
      var text= res
        if(text){
          text = text.replace(/lila/gi, "Guru");
        }
      return text;
    },
    btnClick(e) {
      this.$emit("btnPayload", e);
    },
    formatAMPM(date) {
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
    checkForm() {
      if (
        this.form.name &&
        this.form.companyName &&
        this.form.mobile &&
        this.form.email && 
        this.form.mobile.length == 10 && 
        this.form.email.indexOf('@') > 0 && 
        this.form.email.split('@').pop().indexOf('.') > 1
      ) {
        return false;
      } else {
        return true;
      }
    },
    getPersonName(event) {
      this.form.name = event;
    },
    getCompanyName(event) {
      this.form.companyName = event;
    },
    getMobileNumber(event) {
      this.form.mobile = event;
    },
    getEmail(event) {
      this.form.email = event;
    },
    submitCallback() {
      var submitform = {};
      submitform.name = "name_" + this.form.name;
      submitform.email = "email_" + this.form.email;
      submitform.mobile = "mobile_" + this.form.mobile;
      submitform.companyName = "comapanyName_" + this.form.companyName;
      this.isSubmitClicked = true;
      this.$emit("getUserInput", submitform);
    }
  }
};
</script>

<style scoped>
.treatNewLine {
  white-space: pre-line;
}
.botText {
  background-color: white;
  padding: 0px 8px 0px 4px;
  margin: 5px;
  border-radius: 6px;
  font-size: 0.85rem;
  text-align: justify;
  font-size: 13px;
  font-weight: 500;
  font-family: "Source Sans Pro", sans-serif;
}
#bot .col-sm-1 {
  max-width: 8% !important;
}
#bot .col-sm-9 {
  max-width: 82%;
}
.avatarL {
  display: flex;
  flex-direction: column;
  -webkit-box-align: center;
  align-items: center;
  text-align: center;
  font-size: 0.7em;
  line-height: 1.6em;
  max-width: 35px;
  -webkit-box-flex: 0;
  flex-grow: 0;
  margin: 0px 0.3em 0px 0px;
  padding: 6px;
}
#bot .chat-btn {
  font-size: 14px;
  width: 80%;
  margin: 5px;
  border-radius: 19px;
  font-size: 0.85rem;
  word-break: break-word;
}
#bot .botCard img {
  margin: 3px 10px;
  width: 80px;
}
#bot .botCard {
  border-radius: 19px;
  padding: 5px 0px 7px 0px;
  background: #ffffff !important;
  /*box-shadow: 0 0 0.75rem rgba(0, 0, 0, .16)!important;*/
}
.chat-btn {
  color: #4f678c !important;
  border-color: #4f678c !important;
  background: #ffffff !important;
}
.chat-btn:hover {
  color: #ffffff !important;
  background-color: #4f678c !important;
  border-color: #4f678c !important;
}
.btn:focus,
.btn:active {
  outline: none !important;
  box-shadow: none;
}
.form-control:focus,
.form-control:active {
  outline: none !important;
  box-shadow: none;
}
.timestamp {
  text-align: left;
  margin-left: 6px;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.1px;
  line-height: 14px;
  color: #a5a5a5;
  margin-bottom: 4px;
}
.eip-link {
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 600;
  background-color: #ffffff;
  cursor: pointer;
  border: solid 1px #0e5d84;
  color: hsl(200, 81%, 29%);
  font-size: 15px;
  font-weight: bold;
  outline: none;
  width: auto;
}
.eip-link:disabled {
  color: #0e5d84 !important;
  cursor: not-allowed;
  background-color: #ffffff;
}
</style>
